import { ref, onMounted } from '@vue/composition-api'
import store from '@/store'

export default function usePromosList() {
  const promosSelectList = ref([])
  const FetchPromos = () => {
    promosSelectList.value = []
    store
      .dispatch('promos/apiCall', {
        mode: 'Select',
        request: {
          all: process.env.VUE_APP_API_ALL,
          srt: 'name',
          desc: false,
        },
      })
      .then(response => {
        if (response.success) {
          promosSelectList.value = response.data.items
        }
      })
  }
  onMounted(() => {
    FetchPromos()
  })

  return {
    promosSelectList,
  }
}
